import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import Notifications from './Notifications.jsx'; 

const AdminHeader = ({ onMenuToggle }) => {
  const navigate = useNavigate();
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 480);
  
  const adminUser = JSON.parse(localStorage.getItem('adminUser') || '{}');

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 480);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUser');
    toast.success('Logged out successfully');
    navigate('/admin/login');
  };

  return (
    <header className="admin-header" style={{ 
      background: 'var(--bg-white)',
      borderBottom: '1px solid var(--border-light)',
      padding: 'var(--space-3) var(--space-4)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      boxShadow: 'var(--shadow-sm)',
      position: 'sticky',
      top: 0,
      zIndex: 100,
      minHeight: '56px',
      flexWrap: 'wrap'
    }}>
      {/* Left side with menu toggle and title */}
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: 'var(--space-3)',
        flex: 1,
        minWidth: 0 /* Allow text truncation */
      }}>
        {/* Mobile Menu Toggle */}
        <button 
          onClick={onMenuToggle}
          className="mobile-menu-toggle"
          aria-label="Toggle menu"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0
          }}
        >
          ☰
        </button>

        <h1 style={{ 
          fontSize: 'var(--font-size-lg)', 
          color: 'var(--text-dark)',
          margin: 0,
          fontWeight: '600',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }}>
          {isSmallScreen ? 'Admin' : 'Admin Dashboard'}
        </h1>
      </div>
      
      {/* Right side with notifications, user, and logout */}
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: 'var(--space-2)',
        flexShrink: 0
      }}>
        {/* Notifications Component */}
        <Notifications />
        
        {/* User Info - Compact on small screens */}
        <div style={{ 
          display: 'flex', 
          alignItems: 'center', 
          gap: 'var(--space-2)',
          padding: isSmallScreen ? '4px' : 'var(--space-2) var(--space-3)',
          backgroundColor: 'var(--bg-light)',
          borderRadius: 'var(--radius-lg)',
          border: '1px solid var(--border-light)',
          minHeight: '32px'
        }}>
          <div className="user-avatar" style={{
            width: isSmallScreen ? '24px' : '32px',
            height: isSmallScreen ? '24px' : '32px',
            borderRadius: '50%',
            backgroundColor: 'var(--accent-gold)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'var(--text-dark)',
            fontWeight: '600',
            fontSize: isSmallScreen ? 'var(--font-size-xs)' : 'var(--font-size-sm)',
            flexShrink: 0
          }}>
            {adminUser.name?.charAt(0) || 'A'}
          </div>
          
          {!isSmallScreen && (
            <span className="user-name" style={{ 
              fontWeight: '500',
              fontSize: 'var(--font-size-sm)',
              whiteSpace: 'nowrap'
            }}>
              {adminUser.name?.split(' ')[0] || 'Admin'}
            </span>
          )}
        </div>
        
        {/* Logout Button */}
        <button 
          onClick={handleLogout}
          className="btn btn-secondary logout-btn"
          style={{ 
            padding: isSmallScreen ? '4px 8px' : 'var(--space-2) var(--space-3)',
            fontWeight: '500',
            fontSize: isSmallScreen ? 'var(--font-size-xs)' : 'var(--font-size-sm)',
            minHeight: '32px',
            display: 'flex',
            alignItems: 'center',
            gap: '4px'
          }}
        >
          
          {!isSmallScreen && <span>Logout</span>}
        </button>
      </div>
    </header>
  );
};

export default AdminHeader;